// รวม error message dictionary จากทุกไฟล์ (AddTeacherFail, TeacherHistoryDetailFail,
// AddTeacherHistory ฯลฯ) ไว้ที่เดียว ใช้ได้กับทุกประเภท pre-register
export const errorKeyNote = {
  'The first name eng format is invalid.': 'Format ชื่อภาษาอังกฤษไม่ถูกต้อง',
  'The first name th format is invalid.': 'Format ชื่อภาษาไทยไม่ถูกต้อง',
  'The last name eng format is invalid.': 'Format นามสกุลภาษาอังกฤษไม่ถูกต้อง',
  'The last name th format is invalid.': 'Format นามสกุลภาษาไทยไม่ถูกต้อง',
  'The selected account title th is invalid.': 'คำนำหน้าไม่ถูกต้อง',
  'account_title_eng Invalid value': 'คำนำหน้าภาษาอังกฤษไม่ถูกต้อง',
  'account_title_th Invalid value': 'คำนำหน้าภาษาไทยไม่ถูกต้อง',
  'title_en is not match': 'คำนำหน้าภาษาอังกฤษไม่สอดคล้องกัน',
  'title_th is not match': 'คำนำหน้าภาษาไทยไม่สอดคล้องกัน',
  'email Invalid value': 'Email ไม่ถูกต้อง',
  'mobile_no Invalid value': 'เบอร์มือถือไม่ถูกต้อง',
  'first_name_eng Invalid value': 'ชื่อภาษาอังกฤษไม่ถูกต้อง',
  'first_name_th Invalid value': 'ชื่อภาษาไทยไม่ถูกต้อง',
  'last_name_eng Invalid value': 'นามสกุลภาษาอังกฤษไม่ถูกต้อง',
  'last_name_th Invalid value': 'นามสกุลภาษาไทยไม่ถูกต้อง',
  'id_card_num Invalid value': 'เลขบัตรประจำตัวประชาชนไม่ถูกต้อง',
  'id_card_num is incorrect': 'เลขบัตรประจำตัวประชาชนไม่ถูกต้อง',
  'id card duplicated': 'เลขบัตรประชาชนซ้ำในระบบ',
  'The id card num format is invalid.': 'รูปแบบเลขบัตรประชาชนไม่ถูกต้อง',
  'The id card num must be at least 13 characters.': 'ความยาวของเลขบัตรประชาชนไม่ถูกต้อง',
  'cid is incorrect': 'เลขบัตรประจำตัวประชาชนไม่ถูกต้อง',
  "cid Cannot read properties of undefined (reading 'length')": 'ความยาวของหมายเลขบัตรประชาชนไม่ถูกต้อง',
  'special_title_th Invalid value': 'คำนำหน้านามภาษาไทยไม่ถูกต้อง',
  'special_title_eng Invalid value': 'คำนำหน้านามภาษาอังกฤษไม่ถูกต้อง',
  'position Invalid value': 'ตำแหน่งไม่ถูกต้อง',
  'employee_id Invalid value': 'เลขประจำตัวบุคลากรทางการแพทย์ไม่ถูกต้อง',
  'The mobile no may not be greater than 10 characters.': 'หมายเลขโทรศัพท์มือถือต้องมีความยาวไม่เกิน 10 ตัวอักษร',
  'The username format is invalid.': 'เกิดข้อผิดพลาดในการตั้ง username',
  'The username must be at least 6 characters.': 'ความยาวของชื่อภาษาอังกฤษไม่เพียงพอต่อการ generate username',
  'username already exists in system' : 'username นี้มีในระบบแล้ว',
  'username duplicate' : 'username นี้มีในระบบแล้ว',
  'username is required' : 'กรุณากรอก username',
  'email already exists in system' : 'email นี้มีในระบบแล้ว',
  'Thai Email Cannot Created': 'เกิดข้อผิดพลาดในการสร้างอีเมล',
  'student_id Invalid value': 'เลขประจำตัว นักเรียน/บุคลากร ไม่ถูกต้อง',
  'student_id is duplicated': 'รหัสนักศึกษา/บุคลากร มีซ้ำในระบบ',
  "zipcode can't match": 'รหัสไปรษณีย์ไม่ถูกต้อง',
  "zipcode  can't match": 'รหัสไปรษณีย์ไม่ตรงกับข้อมูล',
  'zipcode Cast to Number failed for value \\NaN\\ (type number) at path \\zipcode\\ for model \\zipcodes\\':
    'รหัสไปรษณีย์ไม่ถูกต้อง',
  'status Invalid value': 'สถานะไม่ถูกต้อง',
  'start_year Invalid value': 'วันที่เริ่มต้นไม่ถูกต้อง',
  'start year Invalid value': 'วันที่เริ่มต้นการศึกษาไม่ถูกต้อง',
  'end_year Invalid value': 'วันที่สิ้นสุดไม่ถูกต้อง',
  'This account_id has not been username.':
    'มี account อยู่แล้ว แต่ยังไม่ตั้ง username กรุณาตั้ง username แล้วอัพโหลดอีกครั้ง',
  'This user is already in the business.': 'ชื่อนี้มีอยู่ใน Business แล้ว',
  'email duplicate': 'Email นี้มีอยู่ในระบบแล้ว',
  'The Email cannot using.': 'Email นี้ไม่มีอยู่จริง',
  'ID card is incorrect': 'หมายเลขบัตรประจำตัวประชาชนไม่ถูกต้อง',
  'tel Invalid value': 'เบอร์โทรศัพท์ไม่ถูกต้อง',
  'district Invalid value': 'อำเภอไม่ถูกต้อง',
  'province Invalid value': 'จังหวัดไม่ถูกต้อง',
  'sub_district Invalid value': 'ตำบลไม่ถูกต้อง',
  'name_th Invalid value': 'ชื่อ (ภาษาไทย) ไม่ถูกต้อง',
  'title_th Invalid value': 'คำนำหน้า (ภาษาไทย) ไม่ถูกต้อง',
  'birth_date Invalid value': 'วันเกิด ไม่ถูกต้อง',
  'name_eng Invalid value': 'ชื่อ (ภาษาอังกฤษ) ไม่ถูกต้อง',
  'title_en Invalid value': 'คำนำหน้า (ภาษาอังกฤษ) ไม่ถูกต้อง',
  'surname_eng Invalid value': 'นามสกุล (ภาษาอังกฤษ) ไม่ถูกต้อง',
  'surname_th Invalid value': 'นามสกุล (ภาษาไทย) ไม่ถูกต้อง',
  'Error': 'ระบบมีปัญหา',
  'cid is required': 'กรุณากรอกเลขบัตรประชาชน',
  'invalid checksum': 'เลขบัตรประชาชนไม่ถูกต้อง',
  'passport invalid value': 'เลขหนังสือเดินทางไม่ถูกต้อง',
  'cid already exists in system': 'เลขบัตรประชาชนนี้มีอยู่ในระบบแล้ว',
  'employee_id is required': 'กรุณากรอกรหัสพนักงาน',
  'Account already have this Dept Role.': 'ชื่อนี้มีอยู่ใน Business แล้ว',
  'AccountId not found.': 'ไม่พบข้อมูลบัญชี One-ID',
  'account_id not found.': 'ไม่พบข้อมูลบัญชี One-ID',
  'username duplicated': 'username ซ้ำใน One',
  'username invalid format': 'username ผิดรูปแบบ (A-Z,a-z,0-9)',
  'username is incorrect': 'username น้อยกว่า 6 ตัว',
  'username Invalid value': 'username ไม่ถูกต้อง',
  'email format is invalid': 'Email ไม่ถูกต้อง',
  'email Duplicate': 'Email ซ้ำในระบบ',
  'employee_id Duplicate': 'รหัสสมาชิกซ้ำ',
  'department Invalid value': 'แผนกไม่ถูกต้อง',
  'portal_id is invalid': 'portal ไม่ถูกต้อง',
  'The mobile no format is invalid.': 'หมายเลขโทรศัพท์มือถือไม่ถูกต้อง',
  'position is required for one-id-pmuc CA': 'กรอกข้อมูล ตำแหน่งของเจ้าของใบรับรอง สำหรับการออกใบรับรอง CA',
  'sub_organization is required for one-id-pmuc CA': 'กรอกข้อมูล ชื่อหน่วยงานย่อยในองค์กรที่เจ้าของใบรับรองสังกัด สำหรับการออกใบรับรอง CA',
  'address is required for one-id-pmuc CA': 'กรอกข้อมูล ที่อยู่ สำหรับการออกใบรับรอง CA',
};

/**
 * แปล response.message (string / array / object) เป็นภาษาไทยแบบ recursive
 * ใช้แทนฟังก์ชัน translateMessage ที่เคยก็อปไว้ใน AddTeacherHistory.jsx
 */
export function translateMessage(message, keyNote = errorKeyNote) {
  if (typeof message === 'string') {
    return keyNote[message] || message;
  }
  if (Array.isArray(message)) {
    return message.map((item) => translateMessage(item, keyNote));
  }
  if (message && typeof message === 'object') {
    const translated = {};
    for (const key in message) {
      translated[key] = translateMessage(message[key], keyNote);
    }
    return translated;
  }
  return message;
}

/**
 * แปลง response.message ให้เป็น array ของข้อความสำหรับแสดงใน modal "หมายเหตุ"
 * ใช้แทน logic ที่เคยก็อปไว้ใน AddTeacherFail.jsx / TeacherHistoryDetailFail.jsx
 */
export function resolveNoteText(message) {
  if (typeof message !== 'string') {
    if (Array.isArray(message)) {
      return message.map((item) => translateMessage(item));
    }
    return Object.values(message || {}).map((item) => translateMessage(item));
  }
  return [errorKeyNote[message] || message];
}